/**
 * Messages für Kartenauswahl-Feedback
 * Reagiert auf Spieler-Interaktion beim Auswählen von Karten
 */

// Gültige Auswahl - kann gespielt werden
export const VALID_SELECTION = [
  "Ja, das klappt. Hau sie raus!",
  "Sieht gut aus. Spielen!",
  "Das geht. Zeig's ihnen!",
  "Perfekt. Ab damit!",
  "Passt! Mach's fertig.",
];

// Gültige Auswahl - starke Kombi
export const STRONG_SELECTION = [
  "Oha, das wird wehtun!",
  "Böse Kombi. Die werden heulen.",
  "Das sitzt! Vernichtung incoming.",
  "Brutal. Mach sie fertig!",
];

// Ungültige Auswahl - passt nicht zusammen
export const INVALID_COMBO = [
  "Das passt nicht zusammen, Bro.",
  "Nee, diese Karten ergeben keinen Sinn.",
  "Kombinier das nochmal neu.",
  "Das ist keine gültige Kombination.",
];

// Ungültige Auswahl - zu schwach
export const TOO_WEAK = [
  "Das schlägt die Karten auf dem Tisch nicht.",
  "Zu schwach. Du brauchst was Stärkeres.",
  "Das reicht nicht. Such was Besseres.",
  "Damit gewinnst du nicht. Höher!",
];

// Ungültige Auswahl - falsche Anzahl
export const WRONG_COUNT = [
  "Falsche Anzahl. Es liegen {count} Karten.",
  "Du brauchst {count} Karten, nicht {selected}.",
  "{count} Karten müssen es sein!",
];

// Auswahl gelöscht
export const SELECTION_CLEARED = [
  "Auswahl zurückgesetzt.",
  "Nochmal von vorn.",
];

// Erste Karte ausgewählt
export const FIRST_CARD_SELECTED = [
  "Eine Karte. Mehr?",
  "Erster Schritt. Weiter?",
];

// Paar ausgewählt
export const PAIR_SELECTED = [
  "Ein Paar. Klassiker.",
  "Doppelt hält besser.",
];

// Drilling ausgewählt
export const TRIPLE_SELECTED = [
  "Drilling! Solide.",
  "Drei Gleiche. Nice.",
];

// Vierling ausgewählt (Bombe)
export const QUAD_SELECTED = [
  "BOMBE! Das wird episch.",
  "Vierling! Totale Vernichtung.",
  "Die Atombombe ist scharf!",
];

// Flush ausgewählt
export const FLUSH_SELECTED = [
  "Flush! Farbe bekennen.",
  "Alles eine Farbe. Schick!",
];

// Straße ausgewählt
export const STRAIGHT_SELECTED = [
  "Straße! Läuft bei dir.",
  "Straight! Sauber aufgereiht.",
];

// Full House ausgewählt
export const FULL_HOUSE_SELECTED = [
  "Full House! Klassiker.",
  "Drilling plus Paar. Mächtig!",
];

// Zwei Pärchen ausgewählt
export const TWO_PAIR_SELECTED = [
  "Zwei Pärchen! Doppelt gemoppelt.",
  "Doppelpaar. Nicht schlecht!",
  "Zwei Paare. Solide Wahl.",
];

// Straight Flush ausgewählt
export const STRAIGHT_FLUSH_SELECTED = [
  "STRAIGHT FLUSH! Das ist brutal!",
  "Straße in Farbe! Absolute Zerstörung.",
  "Die Killercombo! Straight Flush!",
];

// Keine Karten ausgewählt, aber valide Züge vorhanden
export const NO_SELECTION_CAN_PLAY = [
  "Wähl deine Karten aus.",
  "Du hast Optionen. Entscheid dich!",
  "Such dir was aus.",
];

// Keine Karten ausgewählt, keine validen Züge
export const NO_SELECTION_MUST_DRAW = [
  "Keine passenden Karten. Zieh eine!",
  "Nichts dabei. Ab zum Stapel.",
  "Deine Hand ist nutzlos. Ziehen!",
];
